import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { useCursorContext } from '../../providers/CursorProvider';

const CustomCursor: React.FC = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const { cursorType } = useCursorContext();

  useEffect(() => {
    const updatePosition = (e: MouseEvent) => {
      requestAnimationFrame(() => {
        setPosition({ x: e.clientX, y: e.clientY });
      });
    };

    window.addEventListener('mousemove', updatePosition, { passive: true });

    return () => {
      window.removeEventListener('mousemove', updatePosition);
    };
  }, []);

  const getCursorTransform = () => {
    switch (cursorType) {
      case 'arrow-left':
      case 'arrow-right':
      case 'arrow-up':
      case 'arrow-down':
        return 'translate(-50%, -50%) scale(3)';
      case 'pointer':
        return 'translate(-50%, -50%) scale(3)';
      default:
        return 'translate(-50%, -50%) scale(1)';
    }
  };

  const renderCursor = () => {
    switch (cursorType) {
      case 'arrow-left':
        return (
          <Box
            sx={{
              position: 'absolute',
              width: '1rem',
              height: '1rem',
              backgroundColor: '#fff',
              borderRadius: '9999px',
              mixBlendMode: 'difference',
              top: '50%',
              left: '50%',
              transform: getCursorTransform(),
              transition: 'opacity 0.24s ease, transform 0.24s ease',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                position: 'absolute',
                top: 0,
                left: 0,
                fontSize: '1rem',
                alignItems: 'center',
                alignContent: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
                lineHeight: 1,
                color: '#121212',
                transform: 'translate(0) scale(0.5)',
              }}
            >
              <ArrowBackIcon sx={{ fontSize: '1rem' }} />
            </Box>
          </Box>
        );
      case 'arrow-right':
        return (
          <Box
            sx={{
              position: 'absolute',
              width: '1rem',
              height: '1rem',
              backgroundColor: '#fff',
              borderRadius: '9999px',
              mixBlendMode: 'difference',
              top: '50%',
              left: '50%',
              transform: getCursorTransform(),
              transition: 'opacity 0.24s ease, transform 0.24s ease',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                position: 'absolute',
                top: 0,
                left: 0,
                fontSize: '1rem',
                alignItems: 'center',
                alignContent: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
                lineHeight: 1,
                color: '#121212',
                transform: 'translate(0) scale(0.5)',
              }}
            >
              <ArrowForwardIcon sx={{ fontSize: '1rem' }} />
            </Box>
          </Box>
        );
      case 'arrow-up':
        return (
          <Box
            sx={{
              position: 'absolute',
              width: '1rem',
              height: '1rem',
              backgroundColor: '#fff',
              borderRadius: '9999px',
              mixBlendMode: 'difference',
              top: '50%',
              left: '50%',
              transform: getCursorTransform(),
              transition: 'opacity 0.24s ease, transform 0.24s ease',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                position: 'absolute',
                top: 0,
                left: 0,
                fontSize: '1rem',
                alignItems: 'center',
                alignContent: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
                lineHeight: 1,
                color: '#121212',
                transform: 'translate(0) scale(0.5)',
              }}
            >
              <ArrowUpwardIcon sx={{ fontSize: '1rem' }} />
            </Box>
          </Box>
        );
      case 'arrow-down':
        return (
          <Box
            sx={{
              position: 'absolute',
              width: '1rem',
              height: '1rem',
              backgroundColor: '#fff',
              borderRadius: '9999px',
              mixBlendMode: 'difference',
              top: '50%',
              left: '50%',
              transform: getCursorTransform(),
              transition: 'opacity 0.24s ease, transform 0.24s ease',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                position: 'absolute',
                top: 0,
                left: 0,
                fontSize: '1rem',
                alignItems: 'center',
                alignContent: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
                lineHeight: 1,
                color: '#121212',
                transform: 'translate(0) scale(0.5)',
              }}
            >
              <ArrowDownwardIcon sx={{ fontSize: '1rem' }} />
            </Box>
          </Box>
        );
      case 'pointer':
        return (
          <Box
            sx={{
              position: 'absolute',
              width: '1rem',
              height: '1rem',
              backgroundColor: '#fff',
              borderRadius: '9999px',
              mixBlendMode: 'difference',
              top: '50%',
              left: '50%',
              transform: getCursorTransform(),
              transition: 'opacity 0.24s ease, transform 0.24s ease',
            }}
          />
        );
      default:
        return (
          <Box
            sx={{
              position: 'absolute',
              width: '1rem',
              height: '1rem',
              backgroundColor: '#fff',
              borderRadius: '9999px',
              mixBlendMode: 'difference',
              top: '50%',
              left: '50%',
              transform: getCursorTransform(),
              transition: 'opacity 0.24s ease, transform 0.24s ease',
            }}
          />
        );
    }
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        pointerEvents: 'none',
        mixBlendMode: 'difference',
        zIndex: 9999,
        display: { xs: 'none', sm: 'none', md: 'block' },
        willChange: 'transform',
      }}
      style={{
        transform: `translate3d(${position.x}px, ${position.y}px, 0)`,
      }}
    >
      {renderCursor()}
    </Box>
  );
};

export default CustomCursor;
